import "core-js/modules/web.dom-collections.iterator.js";
import React, { useState } from 'react';
import { IconButton, StandardButton } from '@eika/button';
import { IconTypes } from '@eika/icon';
import { Link } from '@eika/link';
import { Modal, ModalTypes } from '@eika/modal';
const NonUsTaxRelationsHelpModalCorporate = _ref => {
  let {
    className
  } = _ref;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const closeModal = () => setIsModalOpen(false);
  const showModal = e => {
    e.preventDefault();
    setIsModalOpen(true);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconButton, {
    className: className,
    onClick: showModal,
    icon: IconTypes.INFO_20,
    id: "help-icon-overall-tax-relations",
    screenReaderText: "Hjelpetekst"
  }), /*#__PURE__*/React.createElement(Modal, {
    onClose: closeModal,
    show: isModalOpen,
    id: "helpermodal__modal",
    type: ModalTypes.STANDARD,
    appNamespace: "kyc-declaration.app"
  }, /*#__PURE__*/React.createElement("div", {
    role: "tooltip",
    id: "helpermodal"
  }, /*#__PURE__*/React.createElement("p", null, "En virksomhet regnes som skattemessig hjemmeh\xF8rende i det eller de landene der de har skattemessige forpliktelser etter det relevante landets interne rett, p\xE5 grunnlag av sted for ledelse, stiftelse, registrering og s\xE5 videre. En virksomhet kan v\xE6re skattemessig hjemmeh\xF8rende i flere land."), /*#__PURE__*/React.createElement("p", null, "For eksempel kan det bero p\xE5 om selskapet er stiftet i henhold til norsk selskapsrett eller om selskapet ut fra vurdering av flere faktorer, anses \xE5 ha reell ledelse i Norge. En virksomhet som er registrert i utlandet vil kunne anses som skattemessig hjemmeh\xF8rende i Norge dersom det reelt sett m\xE5 anses ledet fra Norge p\xE5 styreniv\xE5. Enheter som ikke er skattemessig hjemmeh\xF8rende i noe land, skal i utgangspunktet regnes som hjemmeh\xF8rende p\xE5 stedet der hovedkontorets adresse ligger."), /*#__PURE__*/React.createElement("p", null, "Er det uklart hvor virksomheten er skattemessig hjemmeh\xF8rende, ta kontakt med myndighetene i det aktuelle landet eller ta kontakt med en skatter\xE5dgiver."), /*#__PURE__*/React.createElement("p", null, "For mer informasjon, velg aktuelt land i f\xF8lgende link:", /*#__PURE__*/React.createElement(Link, {
    href: "http://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-residency",
    target: "_blank",
    rel: "noreferrer"
  }, "http://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-residency")), /*#__PURE__*/React.createElement(StandardButton, {
    className: "help-modal-button",
    onClick: closeModal
  }, "Lukk"))));
};
export default NonUsTaxRelationsHelpModalCorporate;